import { useTranslation } from 'react-i18next';
import { AppContext } from '../../services/AppContext';
import { React, useContext, useEffect, useState } from 'react';
import MultiSelector from '../../components/global/MultiSelector';

const AdminDashboard = () => {
    const { apiClient, user } = useContext(AppContext);
    const { t } = useTranslation();
    const [dashboardData, setDashboardData] = useState();
    const [selectedMonth, setSelectedMonth] = useState();
    const [tagData, setTagData] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);

    const fetchTags = async () => {
        const data = await apiClient.getTags();

        if (!data.hasErrors) {
            setTagData(data);
        }
    };

    const fetchData = async (month) => {
        if (user.role !== 'Admin') {
            return;
        }

        let now = new Date();

        if (month) {
            now = new Date(month);
        }

        month = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1, 0, 0, 0)).toISOString();
        var until = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1, 0, 0, 0)).toISOString();
        const data = await apiClient.getAdminStats({
            from: month,
            to: until,
            tags: selectedTags
        });

        if (!data.hasErrors) {
            setDashboardData(data);
        }
    };

    useEffect(() => {
        fetchData(selectedMonth);
    }, [selectedMonth, selectedTags]);

    useEffect(() => {
        fetchTags();
    }, []);

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
    };

    return (
        <div className="dashboard">
            {dashboardData && (
                <div>
                    <h2 className="dashboard-title">{t('dashboard.admin.title')}</h2>
                    <div className="tiles">
                        <div className="tile" onClick={() => window.location.href = '/managers'}>
                            <h3 className="tile-title">{t('common.managers')}</h3>
                            <p>{dashboardData.managers} {t('dashboard.total')}</p>
                        </div>
                        <div className="tile" onClick={() => window.location.href = '/customers'}>
                            <h3 className="tile-title">{t('common.customers')}</h3>
                            <p>{dashboardData.customers} {t('dashboard.total')}</p>
                        </div>
                        <div className="tile" onClick={() => window.location.href = '/subscriptions'}>
                            <h3 className="tile-title">{t('dashboard.subscriptions')}</h3>
                            <p>{dashboardData.activeSubscriptions} {t('dashboard.total')}</p>
                        </div>
                    </div>
                    <div className="select-month-combobox">
                        <select
                            id="month"
                            value={selectedMonth}
                            onChange={handleMonthChange}
                        >
                            {[...Array(6).keys()].map(offset => {
                                const date = new Date();
                                date.setDate(1);
                                date.setMonth(new Date().getMonth() - offset);
                                if (date < new Date(2024, 11, 1)) return null;
                                const value = date.toISOString().split('T')[0].slice(0, 7);
                                const monthName = date.toLocaleString('default', { month: 'long' }).toLocaleLowerCase();
                                const letters = monthName.replace(/[^a-zA-Z]/g, '');
                                const translated = !/^[a-zA-Z]+$/.test(letters);

                                return (
                                    <option key={value} value={value}>
                                        {translated ? date.toLocaleString('default', { month: 'long' }) : t(`common.months.${date.toLocaleString('default', { month: 'long' }).toLocaleLowerCase()}`)} {date.toLocaleString('default', { year: 'numeric' })}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className="select-month-combobox">
                        <MultiSelector options={tagData} selection={selectedTags} onChange={(selection) => setSelectedTags(selection)} isReadOnly={false} closeOnSelection={true} />
                    </div>
                    <div className="stats">
                        <div className="stat">
                            <h3 className="stat-title">{t('dashboard.attendance')}</h3>
                            <p>{dashboardData.attendenceForMonth}</p>
                        </div>
                        <div className="stat">
                            <h3 className="stat-title">{t('dashboard.subscriptionsSold')}</h3>
                            <p className='align-text-left'>{t('dashboard.count')}: {dashboardData.subscriptionsBoughtForMonth}</p>
                            <p className='align-text-left'>{t('dashboard.volume')}: {dashboardData.subscriptionsBoughtVolumeForMonth.amount} {dashboardData.subscriptionsBoughtVolumeForMonth.currency.symbol}</p>
                        </div>
                        <div className="stat">
                            <h3 className="stat-title">{t('dashboard.expired')}</h3>
                            <p className='align-text-left'>{t('dashboard.count')}: {dashboardData.expiredClassesForMonth}</p>
                            <p className='align-text-left'>{t('dashboard.percentage')}: {dashboardData.expiredClassesFractionForMonth}%</p>
                            <p className='align-text-left'>{t('dashboard.volume')}: {dashboardData.expiredClassesVolumeForMonth.amount} {dashboardData.expiredClassesVolumeForMonth.currency.symbol}</p>
                        </div>

                        {
                            dashboardData.discountVolumeForMonth?.amount > 0 && (<div className="stat">
                                <h3 className="stat-title">{t('common.discount')}</h3>
                                <p className='align-text-left'>{t('dashboard.volume')}: {dashboardData.discountVolumeForMonth.amount} {dashboardData.discountVolumeForMonth.currency.symbol}</p>
                            </div>
                            )
                        }

                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminDashboard;
